// extracted by mini-css-extract-plugin
export default {"responsiveGrid":"AgoraPlayer_responsiveGrid__GZH+T","videoSlot":"AgoraPlayer_videoSlot__uCUBY"};